import { UniProfileWrapper } from "@modules/study/university";
import UniFilteredCourses from "@modules/study/university/uni_filtered_courses";
import { excerpt } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { LayoutMain } from "@unisearch/theme/layout";

const Courses = ({
  universityProfileData,
  courseOverviewText,
  country_name,
  university_name,
  coursesData,
  courseDuration,
  exams,
  levels,
  specializations,
  totalCourseCount,
  tutionFee,
  totalCourses,
  paginate,
}) => {
  const listCourseLd =
    totalCourses &&
    totalCourses?.length > 0 &&
    totalCourses.map((item, i) => {
      const courseLd = `
      {
        "@type": "ListItem",
        "position": ${i + 1},
        "item": {
          "@type": "Course",
          "url":"${
            process.env.NEXT_PUBLIC_URL
          }/study/${country_name}/university/${university_name}/${item?.slug}",
          "name": "${item?.courseName}",
          "description": "${item?.courseName} | ${
        item?.specialization?.specializationName
      } | UniSearch",
          "provider": {
            "@type": "Organization",
            "name": "${universityProfileData?.universityName}",
            "sameAs": "${universityProfileData?.website}"
          }
        }
      }
      `;
      return courseLd;
    });

  const JsonLd = () => {
    {
      return {
        __html: `
        [
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "UniSearch",
            "alternateName": "UniSearch",
            "url": "https://myunisearch.com/",
            "logo": "${process.env.NEXT_PUBLIC_URL}/assets/logo_dark.png",
            "sameAs": [
              "https://www.facebook.com/UniSearchIndia",
              "https://twitter.com/myunisearch",
              "https://www.youtube.com/channel/UCCHQrxOr5olDBxypJUE7qZw",
              "https://myunisearch.com/"
            ]
          },
          {
          "@context": "https://schema.org",
          "@type": "ItemList",
          "itemListElement": [${listCourseLd}]
        }
      ]
    `,
      };
    }
  };

  return (
    <LayoutMain
      footer_with_evaluation
      title={
        universityProfileData
          ? `${universityProfileData?.universityName} - Courses`
          : ""
      }
      metaTitle={
        universityProfileData
          ? `${universityProfileData?.universityName} - Courses`
          : ""
      }
      metaDescription={
        courseOverviewText
          ? excerpt(courseOverviewText, 300)
          : `Explore the courses ${universityProfileData?.universityName} has to offer to find the right program for you!`
      }
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/study/${country_name}/university/${university_name}/courses`}
      JsonLd={JsonLd}
    >
      <>
        <UniProfileWrapper
          isBanner={false}
          uniProfileData={universityProfileData || {}}
        >
          <UniFilteredCourses
            courseOverviewText={courseOverviewText}
            country_name={country_name}
            university_name={university_name}
            coursesData={coursesData}
            universityProfileData={universityProfileData}
            courseDurationData={courseDuration}
            examsData={exams}
            levelsData={levels}
            specializationsData={specializations}
            totalCourseCountData={totalCourseCount}
            tutionFeeData={tutionFee}
            totalCoursesData={totalCourses}
            paginateData={paginate}
          />
        </UniProfileWrapper>
      </>
    </LayoutMain>
  );
};

export default Courses;

export async function getServerSideProps({ res, params }) {
  const { country_name, university_name } = params;
  let props = {
    universityProfileData: "",
    courseLevelData: [],
    courses: [],
    paginateData: "",
    levelSlug: "",
    courseOverviewText: "",
    country_name,
    university_name,

    // news system
    coursesData: "",

    courseDuration: {},
    exams: [],
    levels: [],
    specializations: [],
    totalCourseCount: 0,
    tutionFee: {},
    totalCourses: [],
    paginate: {},
  };

  try {
    const res = await API.post(
      `/public/university/all-courses/${university_name}`,
      { limit: 8, page: 1 }
    );
    if (res.data && !res.error) {
      props.coursesData = res.data;

      props.levels = res.data.levels ?? [];
      props.exams = res.data.exams ?? [];
      props.specializations = res.data.specializations ?? [];
      props.totalCourseCount = res.data.totalCourseCount ?? 0;
      props.courseDuration = res.data.courseDuration ?? {};
      props.tutionFee = res.data.tuitionFee ?? {};
      props.totalCourses = res.data.paginatedCourse.courses ?? [];
      props.paginate = res.data.paginatedCourse ?? {};
    }

    await API.get(`/public/university/${university_name}`).then((resp) => {
      if (!resp.error && resp.data) {
        props.universityProfileData = resp.data;
      } else {
        props.universityProfileData = "";
      }
    });

    await API.get(`/public/university/get-overview/${university_name}`).then(
      (resp) => {
        if (!resp.error && resp.data) {
          props.courseOverviewText = resp.data.courseOverview;
        }
      }
    );

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
